// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SparklineComponentWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.SparklineComponentWrapper .SparklineComponentSubtitle {
  font-size: 12px;
  color: var(--gray_dark1);
}`, "",{"version":3,"sources":["webpack://./src/components/Sparkline/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,wBAAA;AACJ","sourcesContent":[".SparklineComponentWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .SparklineComponentSubtitle {\n    font-size: 12px;\n    color: var(--gray_dark1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
